import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { DismantlingBayType } from "../models/DismantlingBay";
import { IProductionManagerOverviewResponse } from "../models/ProductionManager";

export default function useProductionManagerOverview(type: DismantlingBayType) {
  const { get } = useApiHelper();

  const overview = useQuery({
    queryKey: ["production-manager-overview", type],
    queryFn: () =>
      get<IProductionManagerOverviewResponse>(`/productionmanager/overview?type=${type}`),
    staleTime: 1000 * 15,
    refetchInterval: 1000 * 30,
  });

  return { overview };
}
